import { render } from "./OtpInput.vue?vue&type=template&id=a74fb560&scoped=true"
import script from "./OtpInput.vue?vue&type=script&lang=js"
export * from "./OtpInput.vue?vue&type=script&lang=js"

import "./OtpInput.vue?vue&type=style&index=0&id=a74fb560&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a74fb560"

export default script